<template>
  <div>
    <AppHeader fixed style="margin-top: -60px;">
      <a @click="$router.go(-1)">
        <h2 style=" float: left;">
          <i class="fa fa-arrow-circle-left" style="margin-top: 5px; margin-left: 4px;"></i>
        </h2>
        <img
          class="navbar-brand-full"
          src="https://postrapido.s3.us-east-2.amazonaws.com/logos/logo-header.png"
          width="auto"
          height="35"
          style="float: left;"
          alt="Sleeker Logo'"
        /> 
      </a>
      <b-navbar-nav class="ml-auto">
        
        <a
          v-if="me && me.subscription && (me.subscription.status == 0 || (me.subscription.status == 2 && me.subscription.credits > 0) ) && !isMobile"
          class="nav-link active"
          href="#"
          @click="goToPayments()"
        >
          <span class="badge badge-danger">CONTA FREE</span>
        </a>
        <a
          v-else-if="me && me.subscription && me.subscription.status == 1 && !isMobile"
          class="nav-link active"
        >
          <span class="badge badge-info text-white" href="#" @click="goToAccount()">CONTA {{(me && me.subscription && me.subscription.planType == 'VIP') ? 'VIP' : 'PREMIUM'}}</span>
        </a>
        <a
          v-else-if="me && me.subscription && me.subscription.status == 3 && me.subscription.credits && !isMobile"
          class="nav-link active"
        >
          <span class="badge badge-info text-white" href="#" @click="goToAccount()">CONTA {{(me && me.subscription && me.subscription.planType == 'VIP') ? 'VIP' : 'PREMIUM'}}</span>
        </a>
        <a
          v-else-if="me && me.subscription && (me.subscription.status == 2 || (me.subscription.status == 3  && me.subscription.credits <= 0)) && !isMobile"
          class="nav-link active"
        >
          <span class="badge badge-danger">CONTA FREE</span>
        </a>
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div style="margin-top: 60px;">
      <spinner v-if="!document"/>
      <div v-else>
        <b-modal 
          v-model="croppingImage"
          hide-footer
          title="Cortar Imagem"
          size="lg"
          no-close-on-backdrop
        > 
          <b-row>
            <b-col class="text-center" style="padding: 0">
              <image-cropper :imgUrl="imageToCrop" v-on:croppingFinished="croppingFinished" :croppingRatio="croppingRatio"/>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal 
          v-model="selectingImage"
          hide-footer
          title="Selecionar Imagem"
          size="lg"
        > 
          <b-row>
            <b-col cols="12" class="text-center">
              <b-button variant="primary" @click="triggerNewFile" block>Adicionar Foto</b-button>
            </b-col>
            <input
              @change="onFileInputChanged"
              ref="fileInput"
              style="display: none;"
              type="file"
              accept="image/*"
            />
          </b-row>
          <b-row style="margin-top: 10px;">
            <b-col cols="6" class="text-center" v-for="upload, index in uploads" :key="index">
              <div style="width: 100%; border-style: solid;" @click="setNewImage(upload)">
                <img :src="upload" style="max-width: 100%; border-color: #146f8f;"/>
              </div>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal 
          v-model="changingText"
          hide-footer
          title="Alterar Text"
        > 
          <b-row>
            <b-col>
              <b-textarea rows="8" v-model="textToChange"></b-textarea>
            </b-col>
          </b-row>
          <b-row style="margin-top: 15px;">
            <b-col class="text-right">
              <b-button @click="changingText = false">Cancelar</b-button>
              <b-button @click="finishChangingText" variant="primary" style="margin-left: 8px;">Confirmar</b-button>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal 
          v-model="savingDocument"
          hide-footer
          title="Finalizar"
        > 
          <b-row>
            <b-col>
              <p>Configure o link de ação dos botões e confirme para Finalizar a edição:</p>
            </b-col>
          </b-row>
          <b-row style="margin-top: 15px;">
            <b-col class="text-right">
              <b-button @click="savingDocument = false">Cancelar</b-button>
              <b-button @click="saveDocument" variant="primary" style="margin-left: 8px;">Confirmar</b-button>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal 
          v-model="changingColor"
          hide-footer
        > 
          <template #modal-title>
            <b-row>
              <b-col cols="12" class="text-center">
                Trocar Cor
              </b-col>
            </b-row>
          </template>
          <chrome-picker
            v-model="selectedColor"
            style="margin-left: auto; margin-right: auto;"
          />
          <b-row style="margin-top: 15px;">
            <b-col class="text-right">
              <b-button @click="changingColor = false">Cancelar</b-button>
              <b-button @click="finishChangingColor" variant="primary" style="margin-left: 8px;">Confirmar</b-button>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal 
          v-model="changingFont"
          hide-footer
          title="Trocar Fonte"
        > 
          <b-row style="margin-top: 15px;">
            <b-col class="text-right">
              <b-list-group-item v-for="(font, index) in fonts" v-bind:key="index">
                  <button
                    v-b-tooltip.hover
                    title="Alterar fonte"
                    class="btn btn-block"
                    @click="finishChangingFont(font)"
                    type="button"
                    v-bind:style="'font-family: ' + font"
                  >{{font}}</button>
                </b-list-group-item>
              <b-button @click="changingFont = false">Cancelar</b-button>
            </b-col>
          </b-row>
        </b-modal>
        <b-row v-if="!isMobile">
          <b-col sm="12">
              <div id="gjs" style="margin: auto;"></div>
          </b-col>
          <b-col sm="12">
              <b-row>
                <b-col cols="10" offset="1" class="text-center" style="height: 55px; font-size: 180%; color: white; background-color: #ffc107; margin-top: 10px;" @click="undo">
                  <b-row>
                    <b-col cols="6" class="text-right">
                      <i class="fa fa-undo"></i>
                    </b-col>
                    <b-col cols="6" class="text-left">
                      Desfazer
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="10" v-if="!saving" offset="1" class="text-center" style="height: 55px; font-size: 180%; color: white; background-color: #82d0f5; margin-top: 10px;" @click="previewPage">
                  <b-row>
                    <b-col cols="6" class="text-right">
                      <i class="fa fa-eye"></i>
                    </b-col>
                    <b-col cols="5" class="text-left">
                      Visualizar
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="10" v-if="!saving" offset="1" class="text-center" style="height: 55px; font-size: 180%; color: white; background-color: #4dbd74; margin-top: 10px;" @click="savingDocument = true">
                  <b-row>
                    <b-col cols="6" class="text-right">
                      <i class="fa fa-check"></i>
                    </b-col>
                    <b-col cols="6" class="text-left">
                      Finalizar
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="10" v-if="saving" offset="1" class="text-center" style="height: 55px; font-size: 180%; color: white; margin-top: 10px;" @click="savingDocument = true">
                  <spinner />
                </b-col>
              </b-row>
          </b-col>
        </b-row>
        <div style="width: 100%;" v-if="isMobile">
          <b-row>
            <b-col cols="12" class="text-center">
              <div id="gjs" style="margin: auto;"></div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div style="position: fixed; bottom: 0px; width: 96%; left: 0%; background-color: #82d0f5; z-index: 999999999" v-if="isMobile && !changingText">
        <b-row>
          <b-col cols="4" class="text-center" v-if="!saving" style="font-size: 180%; color: white;" @click="previewPage">
            <i class="fa fa-eye"></i>
            <div style="margin-top: -14px;">
              <small style="font-size: 40%;">Visualizar</small>
            </div>
          </b-col>
          <b-col cols="4" class="text-center" v-if="!saving" style="font-size: 180%; color: white; background-color: #ffc107" @click="undo">
            <i class="fa fa-undo"></i>
            <div style="margin-top: -14px;">
              <small style="font-size: 40%;">Desfazer</small>
            </div>
          </b-col>
          <b-col cols="4" class="text-center" v-if="!saving" style="font-size: 180%; color: white; background-color: #4dbd74" @click="savingDocument = true">
            <i class="fa fa-check"></i>
            <div style="margin-top: -14px;">
              <small style="font-size: 40%;">Finalizar</small>
            </div>
          </b-col>
          <b-col cols="12" class="text-center" v-if="saving" style="font-size: 180%; color: white;">
            <spinner/>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
//import grapes from "../grapesjs/src/index";
import grapes from "grapesjs";
import grapesjsTouch from 'grapesjs-touch';
import "grapesjs/dist/css/grapes.min.css";
import grapesjspresetwebpage from "grapesjs-preset-webpage";
import pt from "grapesjs/locale/pt";
import service from "./../service";
import DocPage from "./pages/DocPage.vue";
import { Chrome } from "vue-color";
import Spinner from "./Spinner.vue"
import { isMobile } from "mobile-device-detect";
import VueCropper from 'vue-cropperjs';
import ImageCropper from './ImageCropper.vue'
import DefaultHeaderDropdownAccnt from "../containers/DefaultHeaderDropdownAccnt";
import {
  Header as AppHeader,
  Footer as TheFooter
} from "@coreui/vue";

export default {
  name: "Docs",
  props: {
    msg: String,
  },
  data: function () {
    return {
      editor: null,
      savingPage: false,
      currentPage: {},
      nameToSave: undefined,
      pageId: undefined,
      pageLoaded: undefined,
      savingEditions: false,
      savingItem: false,
      document: undefined,
      selectedPage: null,
      selectedColor: "fff",
      changingColor: false,
      previousColorIndex: -1,
      pageItems: [],
      uploads: [],
      selectedItem: undefined,
      imageToolbar: [{  attributes: {class: 'fa fa-picture-o'}, command: 'replace-image' }, /*{  attributes: {class: 'fa fa-arrows'}, command: 'tlb-move' },*/  {  attributes: {class: 'fa fa-trash'}, command: 'tlb-delete' }],
      divToolbar: [{  attributes: {class: 'fa fa-trash'}, command: 'tlb-delete' }],
      textToolbarMobile: [{  attributes: {class: 'fa fa-pencil'}, command: 'change-text' }, {  attributes: {class: 'fa fa-font'}, command: 'change-text-font' }, {  attributes: {class: 'fa fa-paint-brush'}, command: 'change-text-color' },  /*{  attributes: {class: 'fa fa-arrows'}, command: 'tlb-move' },*/  {  attributes: {class: 'fa fa-trash'}, command: 'tlb-delete' }],
      textToolbarDesktop: [{  attributes: {class: 'fa fa-font'}, command: 'change-text-font' }, {  attributes: {class: 'fa fa-paint-brush'}, command: 'change-text-color' },  /*{  attributes: {class: 'fa fa-arrows'}, command: 'tlb-move' },*/  {  attributes: {class: 'fa fa-trash'}, command: 'tlb-delete' }],
      colorChangingType: undefined,
      selectedComponent: undefined,
      changingFont: false,
      fonts: [],
      isMobile: isMobile,
      croppingImage: false,
      imageToCrop: undefined,
      croppingRatio: 1,
      textToChange: "",
      changingText: false,
      activeTab: 3,
      selectingImage: false,
      savingDocument: false,
      me: {},
      saving: false,
      pasteEvent: false
    };
  },
  computed: {
    imagePageItems: function() {
       return this.pageItems.filter(i => i.type === 'image')
    },
    textPageItems: function() {
       return this.pageItems.filter(i => i.type === 'text')
    }
  },
  mounted() {
    service.getMe().then(me => {
      this.me = me;

      service.getSitePageById(this.$route.params.id).then(result => {
        this.document = result.sitePage;
        service.getUploads().then(
          response => {
            this.uploads = [];
            if (response && response.result) {
              for (let key in response.result) {
                this.uploads.push(response.result[key].url);
              }
              this.loadGrap();  
            }
          },
          () => {
            this.showError = true;
          }
        );
      });
    });

    service.getFonts().then(result => {
      this.fonts = result.fonts;
    });
  },
  methods: {
    duplicatePage(page) {
      let newPage = {...page};
      this.document.sessions.push(newPage)
    },
    removePage(page) {
      this.document.sessions = this.document.sessions.filter(p => p != page);
    },
    movePageToTheRight(page) {
      let index = this.document.sessions.indexOf(page);
      let newIndex = index + 1;

      if (newIndex < this.document.sessions.length) {
        this.movePage(index, newIndex);
      }
    },
    movePageToTheLeft(page) {
      let index = this.document.sessions.indexOf(page);
      let newIndex = index - 1;

      if (newIndex < this.document.sessions.length) {
        this.movePage(index, newIndex);
      }
    },
    movePage(fromIndex, toIndex) {
      var element = this.document.sessions[fromIndex];
      this.document.sessions.splice(fromIndex, 1);
      this.document.sessions.splice(toIndex, 0, element);
    },
    triggerNewFile() {
      this.$refs.fileInput.click();
    },
    onFileInputChanged(event) {
      let reader = new FileReader();
      var vm = this;
      reader.addEventListener("load", function() {
          vm.setNewImage(reader.result);
      });

      reader.readAsDataURL(event.target.files[0]);
    },
    selectItem: function(pageItem) {
      this.editor.select(undefined);
      pageItem.component.set({/*draggable: true,*/ selectable: true, highlightable: true, hoverable: true});
      this.selectedItem = pageItem;
      this.editor.select(pageItem.component);
    },
    croppingFinished: function(result) {
      this.selectedItem.src = result.dataUrl;
      this.selectedItem.component.set({ src: result.dataUrl});
      this.croppingImage = false;
    },
    changeImage: function() {
      /*const am = this.editor.AssetManager;
      let selectedItem = this.selectedItem;
      let vm = this;
      am.open({
        select(asset, complete) {
          vm.setNewImage(asset.getSrc())
          am.close();
        },
        target: selectedItem.component,
        types: ['image'],
        accept: 'image/*',
      });*/
      this.selectingImage = true;
    },
    setNewImage: function (url) {
      let style = getComputedStyle(this.selectedItem.component.view.el);
      let componentHeight = parseInt(style.height.replace("px",""));
      let componentWidth = parseInt(style.width.replace("px",""));
      let ratio = parseInt(componentWidth) / parseInt(componentHeight);
      this.imageToCrop = url;
      this.croppingRatio = ratio;
      this.croppingImage = true;
      this.selectingImage = false;
      this.selectItem(selectedItem);
    },
    loadGrap: function() {
      if (!document.getElementById("gjs")) {
        setTimeout(this.loadGrap, 200);
        return;
      } 
      
      let editorWidth = (this.isMobile ? "90%" : "1100px");
      let editorHeight = (this.isMobile ? "460px" : "580px");

      this.editor = grapes.init({
        container: "#gjs",
        dragMode: 'absolute',
        i18n: {
          locale: "pt", // default locale
          localeFallback: "pt", // default fallback
          messages: { pt, pt },
        },
        // storageManager: { type: 'none' },
        //plugins: ["gjs-preset-webpage", "gjs-plugin-export"],
        //plugins: [grapesjsTouch, "gjs-plugin-export"],
        plugins: [grapesjsTouch],
        width: editorWidth,
        height: editorHeight,
        pluginsOpts: {
          "gjs-preset-webpage": {
            textCleanCanvas: "Você tem certeza que deseja limpar?",
          },
        },
        canvas: {
          styles: ["https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css"],
        },
        storageManager: {
          id: "gjs-", // Prefix identifier that will be used on parameters
          type: "local", // Type of the storage
          autosave: false, // Store data automatically
          autoload: false, // Autoload stored data on init
          stepsBeforeSave: 1, // If autosave enabled, indicates how many changes are necessary before store method is triggered
        },
        panels: { defaults: [] },
        styleManager: {
          appendTo: document.createElement('divaaa'),
        },
        assetManager: {
          //custom: true,
          assets: this.uploads,
        }
      });

      //Configs extras
      this.editor.Panels.removeButton("options", "export-template"); //escondendo botão de exportar nativo
      //this.editor.Panels.removeButton("options", "export-template"); //escondendo botão de exportar nativo
      this.editor.Panels.removeButton("options", "gjs-open-import-webpage"); //escondendo o botão de importar
      this.editor.Panels.removeButton("options", "canvas-clear"); //escondendo o botão de limpar nativo

      this.changePage(this.document.sessions[0]);

      let vm = this;
      
      //Adding commands
      this.editor.Commands.add('replace-image', function(editor) {
        vm.changeImage();
      });

      this.editor.Commands.add('change-text-color', function(editor) {
        vm.startChangingColor('text');
      });
      
      this.editor.Commands.add('change-text-font', function(editor) {
        vm.changingFont = true;
      });

      this.editor.Commands.add('change-text', function(editor) {
        let string = "";
        for (let key in vm.selectedItem.component.attributes.components.models) {
          let component = vm.selectedItem.component.attributes.components.models[key];
          if (component.attributes.content) {
            string += component.attributes.content;
          } else {
            string += "\n";
          }
        }

        vm.textToChange = string.trim();
        vm.changingText = true;

        return;
      });


      //Finished adding commands

      this.editor.on('asset:close', () => {
        if (vm.selectedItem) {
          setTimeout(function() {
            vm.selectItem(vm.selectedItem);
          }, 100);
        }
      });

      this.editor.on('component:selected', () => {
        const selectedComponent = this.editor.getSelected();
        
        if (!this.selectedItem || selectedComponent != this.selectedItem.component) {
          this.setSelectedItem(selectedComponent);
        }

        this.selectedComponent = this.editor.getSelected();
        const defaultToolbar = selectedComponent.get('toolbar');

        if (selectedComponent.attributes.type=="image") {
          selectedComponent.set({toolbar: vm.imageToolbar});
          this.activeTab = 1;
        } else if (selectedComponent.attributes.type=="text" || selectedComponent.attributes.type=="link") {
          if (this.isMobile) {
            selectedComponent.set({toolbar: vm.textToolbarMobile});
          } else {
            selectedComponent.set({toolbar: vm.textToolbarDesktop});
          }
          this.activeTab = 2;
        } else {
          selectedComponent.set({toolbar: vm.divToolbar});
        }
      });

      this.editor.on('component:deselected', () => {
        if (this.selectedItem) {
          this.selectedItem.component.set({draggable: false, /*selectable: false,*/ highlightable: false, hoverable: false, copyable: false});
          this.selectedItem = null;
        }
      });

      var iframeBody = this.editor.Canvas.getBody();

      iframeBody.addEventListener('paste', (event) => { 
        event.preventDefault();
        if (!vm.pasteEvent){
          vm.pasteEvent = true;
          var text = event.clipboardData.getData('text');
          event.target.ownerDocument.execCommand("insertText", false, text);
        }
        return false;
      });

      
      /*$(iframeBody).on("paste", '[contenteditable="true"]', function(e) {
        e.preventDefault();
        var text = e.originalEvent.clipboardData.getData('text');
        e.target.ownerDocument.execCommand("insertText", false, text);
      });*/

      const rte = this.editor.RichTextEditor;
      rte.remove("link");
      rte.remove("reactiveSetter");

      rte.add('fontSize', {
        icon: `<select class="gjs-field" style="color: white;">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
              </select>`,
          // Bind the 'result' on 'change' listener
        event: 'change',
        result: (rte, action) => rte.exec('fontSize', action.btn.firstChild.value),
        // Callback on any input change (mousedown, keydown, etc..)
        update: (rte, action) => {
          const value = rte.doc.queryCommandValue(action.name);
          if (value != 'false') { // value is a string
            action.btn.firstChild.value = value;
          }
        }
      });
    },
    setSelectedItem: function(component) {
      for (let key in this.pageItems) {
        let pageItem = this.pageItems[key];
        if (pageItem.component === component) {
          this.selectedItem = pageItem;
        }
      }
    },
    undo: function(){
      const um = this.editor.UndoManager;
      um.undo();
    },
    finishChangingPage: function(page) {
      this.selectedPage = page;
      this.pageItems = [];    

      const allComponents = this.getAllComponents(this.editor.DomComponents.getWrapper());
      console.log("checking deleteable");

      for (let key in allComponents) {
        /*if (allComponents[key].attributes.type != "image" && allComponents[key].attributes.type != "text") {
          continue;
        }*/
        allComponents[key].set({draggable: false, selectable: false, resizable: false, highlightable: false, hoverable: false, copyable: false});

        let componentClasses = allComponents[key].getClasses();
        let unselectable = false;
        let unreplaceable = false;
        let deleteable = false;

        if (componentClasses.indexOf("unselectable") >= 0) {
          unselectable = true;
          allComponents[key].set({selectable: false});
        }

        if (componentClasses.indexOf("unreplaceable") >= 0) {
          unreplaceable = true;
        }

        if (componentClasses.indexOf("deleteable") >= 0) {
          deleteable = true;
          console.log("deleteable");
        }
        
        if ((allComponents[key].attributes.type == "image" || allComponents[key].attributes.type == "text" || allComponents[key].attributes.type == "link" || deleteable) && !unselectable && !unreplaceable) {
          let pageItem = {component: allComponents[key], selected: false, type: allComponents[key].attributes.type};

          if (allComponents[key].attributes.type == "image") {
            pageItem.src = allComponents[key].attributes.src;
            allComponents[key].set({ editable: false, selectable: true });
          } else if (allComponents[key].attributes.type == "text") {
            pageItem.content = allComponents[key].attributes.components.models[0].attributes.content;
            allComponents[key].set({selectable: true});
          } else if (allComponents[key].attributes.type == "link") {
            pageItem.type = "text";
            pageItem.content = allComponents[key].attributes.components.models[0].attributes.content;
            allComponents[key].set({selectable: true});
          } else if (deleteable) {
            allComponents[key].set({selectable: true, hoverable: true});
          }

          this.pageItems.push(pageItem);
        }
      }
    },
    changePage: function(page) {
      if (this.selectedPage) {
        this.selectedPage.html = this.editor.getHtml();
        this.selectedPage.css = this.editor.getCss();
        let previousSelectedPage = this.selectedPage;

        service.getScreenshotFromHtml(this.selectedPage.html, this.selectedPage.css, 550, 300).then(result => {
          previousSelectedPage.thumbnail = result.base64;
        });

        this.editor.setStyle("");
      }

      this.clearCanvas();

      if (!page.html) {
        fetch(page.url).then(result => {
          result.text().then((textResult) => {
            this.editor.setComponents(textResult);
            this.finishChangingPage(page);
          })
        });
      } else {
        this.editor.setComponents(page.html);
        if (page.css) {
          this.editor.setStyle(page.css);
        }
        this.finishChangingPage(page);
      }
    },
    getImageDimensions(url, cb) {   
        var img = new Image();
        img.onload = function() {
          cb(img.height, img.width)
        };
        img.src = url;
    },
    getAllComponents(model, result = []) {
      result.push(model);
      model.components().each(mod => this.getAllComponents(mod, result))
      return result;
    },
    startChangingColor(type, index) {
      if (type == 'image') {
        this.selectedColor = this.document.colors[index];
        this.previousColorIndex = index;
      } else if (type == 'text') {

      }

      this.changingColor = true;
      this.colorChangingType = type;
    },
    finishChangingText() {
      let finalText = this.textToChange.replace(/\n/g, "<br/>");
      this.selectedItem.component.components(finalText);
      this.changingText = false;
    },
    finishChangingFont(font) {
      let textStyle = this.selectedComponent.getStyle();
      textStyle["font-family"] = font;
      this.selectedComponent.setStyle(textStyle);
      this.changingFont = false;
    },
    finishChangingColor() {
      let newColor = "rgb(" + this.selectedColor.rgba.r + ", " + this.selectedColor.rgba.g + ", " + this.selectedColor.rgba.b + ")";
      if (this.colorChangingType == "image") {
        let css = this.editor.getCss();
        let newCss = css.replaceAll(this.document.colors[this.previousColorIndex], newColor);
        this.editor.setStyle(newCss);

        for (let key in this.document.sessions) {
          let page = this.document.sessions[key];
          
          if (page != this.selectedPage) {
            if (page.css) {
              while (page.css.indexOf(this.document.colors[this.previousColorIndex]) >= 0) {
                page.css = page.css.replaceAll(this.document.colors[this.previousColorIndex], newColor);
              }
            }

            while (page.html.indexOf(this.document.colors[this.previousColorIndex]) >= 0) {
              page.html = page.html.replaceAll(this.document.colors[this.previousColorIndex], newColor);
            }
          } else {
            page.css = newCss;
            page.html = this.editor.getHtml();
          }

          service.getScreenshotFromHtml(page.html, page.css).then(result => {
            page.thumbnail = result.base64;
          });
        }
      } else if (this.colorChangingType == "text") {
        let textStyle = this.selectedItem.component.getStyle();
        textStyle.color = newColor + " !important";
        this.selectedItem.component.setStyle(textStyle);
      }
      
      this.changingColor = false;
      this.document.colors[this.previousColorIndex] = newColor;
    },
    previewPage: function () {
      this.saving = true;
      this.selectedPage.html = this.editor.getHtml();
      this.selectedPage.css = this.editor.getCss();

      service.updateSitePageSessions(this.document._id, this.document.sessions, this.document.colors).then((result) => {
        this.saving = false;
        window.location.href = result.previewUrl;
      });
    },
    saveDocument: function () {
      this.saving = true;
      this.selectedPage.html = this.editor.getHtml();
      this.selectedPage.css = this.editor.getCss();

      service.updateSitePageSessions(this.document._id, this.document.sessions, this.document.colors).then(() => {
        this.saving = false;
        this.$router.push("/site/home");
      });
    },
    clearCanvas: function () {
      //this.editor.runCommand("canvas-clear");
    },
    downloadPage: function () {
      console.log("Mandou baixar a página");
      this.editor.runCommand("gjs-export-zip"); //faz o download do arquivo em um .zip
    },
    loadPage(page) {
      this.editor.setComponents(page.html);
      this.editor.setStyle(page.css);
      this.editor.store();
      this.pageLoaded = page;
    },
  },
  created: function () {
    
  },
  components: { DocPage, "chrome-picker": Chrome, Spinner, VueCropper, ImageCropper, AppHeader, DefaultHeaderDropdownAccnt }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100% !important;
}

/** ::-webkit-scrollbar  {
  width: 0px !important;
}*/

.scrolling-wrapper ::-webkit-scrollbar  {
  width: 30px !important;
  height: 30px !important;
}

scrolling-wrapper ::-webkit-scrollbar:horizontal {
    height: 11px;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.gjs-cv-canvas {
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
}
</style>
